import CurrencyInput from "react-currency-input-field";
import { Controller } from "react-hook-form";
import { Form, InputGroup } from "react-bootstrap";
import { BsCurrencyEuro } from "react-icons/bs";

const FormFieldCurrency = ({
  label,
  name,
  control,
  validationError,
  placeholder = "Vnesite znesek",
}) => {
  return (
    <Form.Group controlId={label} className="mb-2 mt-3">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            return (
              <CurrencyInput
                id={name}
                name={name}
                placeholder={placeholder}
                defaultValue={field.value}
                intlConfig={{ locale: "sl-SI", currency: "EUR" }}
                decimalsLimit={2}
                onValueChange={(value) => field.onChange(value ? value : null)}
                className="form-control"
              />
            );
          }}
        />
        <InputGroup.Text>
          <BsCurrencyEuro />
        </InputGroup.Text>
      </InputGroup>
      {validationError && <p className="text-danger">{validationError}</p>}
    </Form.Group>
  );
};

export default FormFieldCurrency;

// will used with controler for use with react-hook-form, but can be used as standalone component as well
